import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { AxiosRequestConfig } from "axios";

export interface Factura {
  proveedorRut: string;
  numeroFactura: string;
  estado: string;
  detalleEstado: string;
  nombreEmpresa: string;
  monto: string;
  fechaEmision: string;
  fechaPago: string;
  numeroOrdenCompra: string;
}
export interface Estado {
  nombre: string;
  monto: number;
}

export interface FacturaInfo {
  errors: unknown;
  factura: Factura;
  facturas: Array<Factura>;
  dashboard: Array<Estado>;
}

@Module
export default class FacturaModule extends VuexModule implements FacturaInfo {
  errors = {};
  factura = {} as Factura;
  facturas = [] as Array<Factura>;
  dashboard = [] as Array<Estado>;

  /**
   * Get current factura object
   * @returns Factura
   */
  get currentFactura(): Factura {
    return this.factura;
  }

  /**
   * Get all facturas
   * @returns Array<Factura>
   */
  get allFacturas(): Array<Factura> {
    return this.facturas;
  }

  /**
   * Get dashboard
   * @returns Array<Estado>
   */
  get allDashboard(): Array<Estado> {
    return this.dashboard;
  }

  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_FACTURA_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_FACTURA](factura) {
    this.factura = factura;
  }

  @Mutation
  [Mutations.SET_FACTURAS](facturas) {
    this.facturas = facturas;
  }

  @Mutation
  [Mutations.SET_FACTURA_DASHBOARD](estados) {
    this.dashboard = estados;
  }

  @Action
  [Actions.GET_FACTURAS](param) {
    const params = {
      ...param,
    };
    return ApiService.post("factura/v1/facturas/buscar", params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_FACTURAS, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_FACTURA_ERROR, response.data.errors);
      });
  }
  
  @Action
  [Actions.GET_FACTURAS_REFERENCIA](rut) {
    return ApiService.get(`factura/v1/facturas/referencia/${rut}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_FACTURAS, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_FACTURA_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.GET_FACTURAS_DASHBOARD]() {
    return ApiService.get(`factura/v1/dashboard`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_FACTURA_DASHBOARD, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_FACTURA_ERROR, response.data.errors);
      });
  }
}
